import CardDTO from '@src/adapters/dto/card/CardDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  id: string;
}

interface Result {
  card: CardDTO;
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/card',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useGetCardLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useGetCardLazy;
